import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-card-template',
  imports: [],
  templateUrl: './card-template.component.html',
  styleUrl: './card-template.component.scss',
})
export class CardTemplateComponent {
  @Input() title: string = '';
  @Output() close = new EventEmitter<void>();

  onClose() {
    this.close.emit();
  }
}
